import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Card, CardBody, CardHeader, Label } from "reactstrap";
import { format } from 'date-fns'
import ApiService from "../../services/apiService";
import { method } from "lodash";
import { Console } from "console";

type chartProp = {
    fromDateTime?: string | null;
    toDateTime?: string | null;
    generateKey?: number | null | undefined ;
    id?:number|string,
    pumpNumber?:number|string
  };
const COLORS = ["#2B5F60", "#A3A3A8"]; // Colors for the progress and background

const LoadingChart = ({fromDateTime,toDateTime, generateKey,pumpNumber,id}:chartProp) => {

    const [fromDate, setFromDate] = useState<any>()
    
    const [pumpingStation, setPumpingStation] = useState<any[]>()
    const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null]);
    const [active, setActive] = useState<boolean>(false)
    const [oneActive, setOneActive] = useState<boolean>(false)
    const [toDate, setToDate] = useState<any>()
    const [runningHours,setRunningHours] = useState<any>()


    const progress = 80;
    const formatted = format(new Date(), "dd-MM-yyyy HH:mm:ss");

    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7); 
    startDate.setHours(0, 0, 0, 0);

    useEffect(()=>{
        const getPumpWiseHistory = async () => {

            try {
                const response = await ApiService.axiosApi(`/pumpwisehistory/getpumpwisehistory`, {
                    method: 'GET',
                    params: {
                        PumpingStationId:id?id:'',
                        PumpNumber: pumpNumber?pumpNumber:1 ,
                        FromDate:fromDateTime ? fromDateTime : format(startDate, 'yyyy-MM-dd HH:mm:ss'),
                        ToDate:toDateTime ? toDateTime : format(endDate, 'yyyy-MM-dd HH:mm:ss')
                    }
                })
                if(response.success){
                    const updatedData = {
                        ...response.data,
                        remaining:  100 - response.data.runPercentage 
                      };
                       console.log(updatedData)
                      setRunningHours(updatedData); // store in state
                }else{
                     console.log('Unable to get pump wise history')
                }
            } catch (error) {
                console.log(error)
            }
        }

        getPumpWiseHistory();
         
    },[fromDate,toDate,generateKey])

   

    useEffect(() => {
        const getPumpingStation = async () => {
            try {
                const response = await ApiService.axiosApi(`/pumpstation`, {
                    method: 'GET',
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })
                if (response.success) {
                    setPumpingStation(response.data.data);
                } else {
                    console.log('Unable to get pumping station')
                }
            } catch (error) {
                console.log(error)
            }
        }

        getPumpingStation();
    }, [])


    const setSixMonth = () => {
        const endDate = new Date(); // current date-time
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 6); // subtract 6 months
        const from = format(startDate, 'yyyy-MM-dd HH:mm:ss')
        const to = format(endDate, 'yyyy-MM-dd HH:mm:ss')

        setFromDate(from);
        setToDate(to);

    }

    const setOneYear = () => {
        const endDate = new Date(); // current date-time
        const startDate = new Date();
        startDate.setFullYear(startDate.getFullYear() - 1); // subtract 1 year

        const from = format(startDate, 'yyyy-MM-dd HH:mm:ss')
        const to = format(endDate, 'yyyy-MM-dd HH:mm:ss')


        setFromDate(from);
        setToDate(to)


    }

    return (
        <Card className="m-0 b-r-0">
            <CardHeader>
                <div className="d-flex justify-content-between w">
                 
                <div className="d-flex flex-column">
          <h5 style={{ fontWeight: "600" }}>Pumping Time</h5>
          <h6 style={{ fontSize: "12px" }}>
            {" "}
            {fromDateTime
              ? format(new Date(fromDateTime), "dd/MM/yyyy ")
              : format(startDate, "dd/MM/yyyy ")}{" "}
            -
            {toDateTime
              ? format(new Date(toDateTime), "dd/MM/yyyy")
              : format(endDate, "dd/MM/yyyy ")}
          </h6>
        </div>
                        
               

                </div>
            </CardHeader>
            <CardBody >
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Tooltip />
                    <Pie
                            
                                data={[
                                    { name: 'run', value: runningHours?.runPercentage ?? 0 },
                                    { name: 'remaining', value: runningHours?.remaining ?? 0 }
                                  ]}
                           
                            cx="50%"
                            cy="60%" // Position at the bottom to create a semi-circle
                            innerRadius={60}
                            outerRadius={100}
                            //fill="#8884d8"
                            dataKey="value"
                            startAngle={180} // Start from the left
                            endAngle={0} // End at the right (completing the half-circle)
                        >
                            {/* Coloring the segments */}
                            <Cell key="run" fill={COLORS[0]} />
                            <Cell key="remaining" fill={COLORS[1]} />



                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div
                    style={{
                        position: "absolute",
                        top: "60%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: "#333",
                    }}
                >
                    {runningHours != null ? runningHours.runPercentage.toFixed(2) : 0}%
                </div>
            </CardBody>
        </Card>
    );
};

export default LoadingChart;
